import { BASE_URL, STORAGE_SUF, endpoints } from "../constants"
import { fetchWithAuth } from "../utils/fetchWithAuth"

const suffix = localStorage.getItem(STORAGE_SUF) || ""

export const copyArticle = async (
  url: string,
  loginData: {
    slovakData: string
    slovakIv: string
    czechData: string
    czechIv: string
  },
  onPartialUpdate: (message: string) => void
): Promise<void> => {
  try {
    const response = await fetchWithAuth(`${BASE_URL}/${endpoints.COPY}-${suffix}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ url, loginData }),
    })

    if (!response.ok) {
      throw new Error(`Failed to copy article for URL: ${url}`)
    }

    const reader = response.body?.getReader()

    if (!reader) {
      throw new Error("ReadableStream not supported in this browser.")
    }

    const decoder = new TextDecoder()
    let buffer = ""

    // Read from the stream until done
    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      // Decode the chunk and add it to the buffer
      buffer += decoder.decode(value, { stream: true })
      // Split based on newlines (or your chosen delimiter)
      const parts = buffer.split("\n")
      // Keep the last part if it's incomplete
      buffer = parts.pop() || ""
      // Process complete parts
      parts.forEach((part) => {
        if (part.trim()) {
          onPartialUpdate(part.trim())
        }
      })
    }
  } catch (error) {
    console.error(`Error copying article for URL: ${url}`, error)
    throw error
  }
}
